import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { LocaleProvider } from './i18n/Locale.js';
import './styles.css';
import './hud-hz.css';
import './hud-hz-adv.css';
import './hud-hz-journey.css';
import './hud-hz-fase3.css';
import './hud-hz-menus.css';
import './hud-hz-fb17.css';
import { TextureSource } from 'pixi.js';
import { installPixelSnap } from './ui/pixelSnap.js';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

// Floating windows on whole pixels, so the sprites inside stay crisp.
installPixelSnap();
// Sprites are pixel art everywhere (reference `pixelArt: true`): every texture
// samples nearest-neighbour unless it asks otherwise (light halos).
TextureSource.defaultOptions.scaleMode = 'nearest';

createRoot(root).render(
  <StrictMode>
    <LocaleProvider>
      <App />
    </LocaleProvider>
  </StrictMode>,
);
